import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Button,
  Box,
  Card,
  CardContent,
  Divider,
  Modal,
  Typography
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

import { cash } from 'constants/paymentMethods';

const DailyAccounts = (props) => {

  const columns = [
    { field: 'displayId', headerName: 'ID', flex: 1, sortable: false },
    { field: 'total', headerName: 'Total Amount', flex: 1, sortable: false }
  ];

  const [cashInTableData, setCashInTableData] = useState([]);
  const [CashOutTableData, setCashOutTableData] = useState([]);

  useEffect(() => {
    let cashInBuffer = [];
    let cashOutBuffer = [];
    
    const todaysDate = moment();

    // CASH IN
    // Sales Orders
    for ( let i = 0; i < props.salesOrders.length; i++ ) {
      const currSalesOrder = props.salesOrders[i];
      for ( let j = 0; j < currSalesOrder.payments.length; j++ ) {
        if(todaysDate.isSame(currSalesOrder.payments[j].createdAt, 'day') && currSalesOrder.payments[j].paymentMethod === cash) {
          const payment = currSalesOrder.payments[j];
          cashInBuffer.push({
            displayId: payment.displayId,
            total: payment.amount
          });
        }
      }
    }

    // CASH OUT
    // Expenses
    for ( let i = 0; i < props.expenses.length; i++ ) {
      if (todaysDate.isSame(props.expenses[i].createdAt, 'day')) {
        const expense = props.expenses[i];
        cashOutBuffer.push({
          displayId: expense.displayId,
          total: expense.total
        });
      }
    }
    
    setCashInTableData(cashInBuffer);
    setCashOutTableData(cashOutBuffer);
    
  }, [props.salesOrders, props.expenses, props.month]);

  return (
    <Modal open={props.open}>
      <Card>
        <CardContent>
          <Box>
            <Typography
              color="textPrimary"
              variant="h5"
            >
              Today's Date : {moment().format("DD/MM/YYYY")}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              columnGap: 40,
              marginBottom: '1%'
            }}
          >
            <Typography
              color="textPrimary"
              variant="h6"
            >
              CASH IN : {cashInTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
            >
              CASH OUT : {CashOutTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
            >
              PROFIT : {cashInTableData.reduce((prev, curr) => prev + curr.total, 0) - CashOutTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
            </Typography>
          </Box>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1%'
            }}
          >
            <Box
              sx={{
                height: 474,
                width: '100%'
              }}
            >
              {/* CASH IN */}
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                CASH IN
              </Typography>
              <DataGrid
                rows={cashInTableData}
                columns={columns}
                getRowId={(row) => row.displayId}
                disableSelectionOnClick
                disableColumnMenu
                hideFooter
                localeText={{
                  noRowsLabel: 'No Transactions'
                }}
              />
            </Box>
            <Box
              sx={{
                height: 474,
                width: '100%'
              }}
            >
              {/* CASH OUT */}
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                CASH OUT
              </Typography>
              <DataGrid
                rows={CashOutTableData}
                columns={columns}
                getRowId={(row) => row.displayId}
                disableSelectionOnClick
                disableColumnMenu
                hideFooter
                localeText={{
                  noRowsLabel: 'No Transactions'
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '2%'
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={props.closeModal}
            >
              Close
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  )
};

export default DailyAccounts;